import type { ReactNode } from 'react';
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: '',
});

export const logger = {
  error: (...args: unknown[]) => console.error(...args),
  warn: (...args: unknown[]) => console.warn(...args),
  info: (...args: unknown[]) => console.info(...args),
  debug: (...args: unknown[]) => console.debug(...args),
};

export function useCurrentUserProfile() {
  const token =
    typeof sessionStorage === 'undefined'
      ? null
      : sessionStorage.getItem('admin_token');

  return {
    user_id: token ? 'local-admin' : '',
  };
}

export function CanRole({ children }: { roles?: string[]; children: ReactNode }) {
  return <>{children}</>;
}
